export default "__VITE_ASSET__DbgfohnS__"